// extracted by mini-css-extract-plugin
export var fileUpload = "_ft-1";
export var modalButton = "_ft-0";